import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
import { memo, useEffect, useState } from "react";
import { FormFieldWrapper } from "../../core/shared/FormFieldWrapper";
import { Flex } from "../Flex";
import { Typography } from "../Typography";
import RadioSkeleton from "./Skeleton";
import { Item } from "./styles";
import { Root } from "./Root";
function RadioComponent({ data, onChange, value: initialValue, direction = "row", innerGap = "8px", outerGap = "8px", name, feedback, label: inputLabel, required = false, disabled = false, loading, variant, width, size = 'normal' }) {
    const [checked, setChecked] = useState("");
    const handleValueChange = (selected) => {
        onChange({ currentTarget: { value: selected, name } });
        setChecked(selected);
    };
    useEffect(() => {
        setChecked(initialValue);
    }, [initialValue]);
    return (_jsx(FormFieldWrapper, { label: inputLabel, required: required, disabled: disabled, name: name, onChangeFeedback: () => { }, value: checked, feedback: feedback, children: _jsx(Flex, { width: "100%", gap: outerGap, direction: direction, children: loading
                ? Array.generate(4).map((i) => (_jsx(Flex, { width: "100%", maxWidth: width, alignItems: "center", gap: innerGap, children: _jsx(RadioSkeleton, { variant: variant }) }, i)))
                : data.map(({ label, value, disabled: optionDisabled }) => (_jsxs(Item, { width: "100%", maxWidth: width, alignItems: "center", gap: innerGap, children: [_jsx(Root, { variant: variant, checked: checked.includes(value), id: value, onClick: () => {
                                if (!disabled && !optionDisabled)
                                    handleValueChange(value);
                            }, disabled: disabled || optionDisabled, size: size }), _jsx("label", { htmlFor: value, children: _jsx(Typography, { children: label }) })] }, value))) }) }));
}
const Radio = memo(RadioComponent);
export { Radio };
//# sourceMappingURL=index.js.map